/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Range_AllInputs */

const en_us2_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pt_br2_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo`)
};

const es_419_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo`)
};

const pt_pt2_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo`)
};

const fr_fr2_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout`)
};

const de_de2_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const it_it2_exercise_sheet_range_all = /** @type {(inputs: Exercise_Sheet_Range_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Exercise_Sheet_Range_AllInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_range_all = /** @type {((inputs?: Exercise_Sheet_Range_AllInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Range_AllInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_range_all(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_range_all(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_range_all(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_range_all(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_range_all(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_range_all(inputs)
	return en_us2_exercise_sheet_range_all(inputs)
});
export { exercise_sheet_range_all as "exercise-sheet.range_all" }